<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="110px"
      >
        <el-form-item label="部门" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属条线" prop="txlx">
          <el-select
            ref="txlx"
            v-model="listQuery.txlx"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
            @change="handleChangeTx"
          >
            <el-option
              v-for="item in ygtxoptions"
              :key="item.value"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.name"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
            @change="handleChangeLx"
          >
            <el-option
              v-for="item in lxList"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="子类" prop="sun">
          <el-select
            ref="sun"
            v-model="listQuery.sun"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in zlList"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="节点名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.jdlx"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in jdlxList"
              :key="item.jdlx"
              :label="item.jdlxmc"
              :value="item.jdlx"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="status">
          <el-date-picker
            v-model="time"
            type="daterange"
            size="small"
            style="width: 300px"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="listQuery.createTime"
            @change="handleChangeTime"
            @keyup.enter.native="getList"
          ></el-date-picker>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addDialog = true"
            style="margin-left: 15px"
            >新增</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="操作"
          align="center"
          min-width="80px"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleDelete(scope.row.id)"
              style="margin-left: 15px; color: #ff0000"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="所属条线"
          prop="txlx"
          min-width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="部门"
          prop="bmmc"
          min-width="100px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="任务类型"
          prop="name"
          :show-overflow-tooltip="true"
          min-width="130px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="子类"
          prop="sun"
          min-width="100px"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="节点名称"
          prop="jdlxName"
          min-width="120px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="评审人"
          prop="reviewerList"
          min-width="150px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="border">
              <el-table
                style="width: 100%"
                :data="scope.row.reviewerList"
                :show-header="false"
              >
                <el-table-column
                  align="center"
                  prop="sh"
                  min-width="90px"
                  :show-overflow-tooltip="true"
                />
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建人"
          prop="createBy"
          min-width="120px"
          align="center"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          min-width="120px"
          align="center"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="备注"
          prop="bz"
          min-width="100px"
          align="left"
        ></el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增审核人配置"
      :visible.sync="addDialog"
      width="90%"
      v-if="addDialog"
      id="mx-dialog"
    >
      <Add ref="add" @giveFather="getSon"></Add>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSaveAdd">确定</el-button>
        <el-button @click="addDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑审核人配置"
      :visible.sync="editDialog"
      width="90%"
      v-if="editDialog"
      id="mx-dialog"
    >
      <Edit ref="edit" :mxParams="mxParams" @giveFather="getSon"></Edit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSaveEdit">确定</el-button>
        <el-button @click="editDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import {
  getreviewerList,
  deleteReviewer,
  getJdlxSelector,
} from "@/api/reviewer.js";
import {
  getBmxxList,
  getTasklxList,
  getTaskZlList,
  getKeyValue,
} from "@/api/taskType.js";
import { formatMomentDate } from "@/utils/utils";
import Add from "./add.vue";
import Edit from "./edit.vue";
import { deepClone } from "../../utils/utils";
export default {
  // 列表分页
  name: "taskType",
  components: { Pagination, Add, Edit },

  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      height: 100,
      listQuery: {
        txlx: "",
        bmbh: "",
        name: "",
        sun: "",
        jdlx: "",
        ksTime: "",
        jsTime: "",
        page: 1,
        pageSize: 10,
      },
      listLoading: false,
      time: [],
      total: 0,
      list: [],
      jdlxList: [],
      bmList: [],
      lxList: [],
      zlList: [],
      ygtxoptions: [],
      saveFormParams: {
        id: "",
        bmbh: "",
        bmmc: "",
        bz: "",
      },
      saveForm: {
        title: "新增",
      },
      options: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      addDialog: false,
      editDialog: false,
      mxParams: {},
    };
  },
  created() {
    this.getList();
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    getJdlxSelector().then((res) => {
      if (res.code == 0) {
        this.jdlxList = res.data.jdlxList;
      }
    });
    getTasklxList().then((res) => {
      if (res.code == 0) {
        this.lxList = res.data;
      }
    });
    getTaskZlList().then((res) => {
      if (res.code == 0) {
        this.zlList = res.data;
      }
    });
    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });
    this.$store.dispatch("common/fetchUserInfoAction");
  },
  methods: {
    getList() {
      this.listLoading = true;
      getreviewerList(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        } else {
          this.listLoading = false;
        }
      });
    },

    handleChangeTx() {
      getTasklxList(this.listQuery.bmbh, this.listQuery.txlx).then((res) => {
        if (res.code == 0) {
          this.lxList = res.data;
        }
      });
    },

    handleChangeBm(i) {
      this.listQuery.bmbh = i;
      this.listQuery.bmmc = i;

      getKeyValue("TXLX", i, "1").then((res) => {
        if (res.code === 0) {
          this.ygtxoptions = res.data;
        }
      });
    },

    handleChangeLx() {
      getTaskZlList(
        this.listQuery.name,
        this.listQuery.bmbh,
        this.listQuery.txlx
      ).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteReviewer(id);
        })
        .then((res) => {
          if (res.code == 0) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleChangeTime(value) {
      if (!value) {
        this.listQuery.ksTime = "";
        this.listQuery.jsTime = "";
        return;
      }
      this.listQuery.ksTime = formatMomentDate(value[0]);
      this.listQuery.jsTime = formatMomentDate(value[1]);
    },
    handleSaveAdd() {
      this.$refs.add.handleAdd();
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    handleEdit(row) {
      this.editDialog = true;
      this.mxParams = row;
    },
    handleSaveEdit() {
      this.$refs.edit.handleEdit();
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    getSon(temp) {
      this.addDialog = temp;
      this.editDialog = temp;
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

